/*
 * @Author: your name
 * @Date: 2021-08-20 12:06:25
 * @LastEditTime: 2021-11-15 13:52:14
 * @LastEditors: Please set LastEditors
 * @Description: 全局状态存储
 * @FilePath: \vue-element-ui-admin\src\store\index.js
 */
import Vue from "vue";
import Vuex from "vuex";
import { app } from "./modules/app.js";
import { menu } from "./modules/menu.js"; //菜单
import { system } from "./modules/system.js"; //布局需要的一些数据
import { routes } from "./modules/routes.js"; //路由链，当有多层子路由时，需要保存每一级路由所有参数，方便面包屑使用，并且刷新不丢失
import code from "./modules/code";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    system,
    menu,
    routes,
    code
  }
});
